import React from 'react';

const ActivitiesMarket = () => {
  return (
    <section id="activities-market">

      <h1>Piaccsarnok és piactér üzemeltetés</h1>

      <header>

        <div id="activities-market-info">

          <h2>Csarnok nyitvatartás:</h2>
          <ul>
            <li>H 11.00-17.00</li>
            <li>K-P 6.00-17.30</li>
            <li>Sz 6.00-12.00</li>
            <li>V Zárva</li>
          </ul>

          <h2>Piaci napok:</h2>
          <ul>
            <li>Kedd</li>
            <li>Csütörtök</li>
            <li>Szombat</li>
          </ul>

          <h2>Piacfelügyelő:</h2>
          <ul>
            <li>Molnár István</li>
          </ul>

          <h2>Elérhetőség:</h2>
          <ul>
            <li><a href="tel: +36 30/299-9566">30/299-9566</a></li>
          </ul>

        </div>

        <div id="activities-market-img"></div>

      </header>

      <div id="activities-market-text">

        <div>
          <p>
            2013. március 1-jétől a városi piaccsarnok üzemeltetésével bővült a Kft. működési köre
          </p>

          <p>
            A tevékenységen belül feladatunk a városi piaccsarnok működtetése, üzemeltetése, a nyitott és zárt eladóterületen az árusok kulturált helyének biztosítása. Az önkormányzat és más hatóságok ide vonatkozó rendeleteinek betartása, illetve betartatása. A helypénzek, bérleti díjak beszedése, bérleti szerződések megkötése. 
          </p>

          <p>
            A feladat ellátásához 1 fő munkavállaló áll rendelkezésünkre.
          </p>

        </div>

        <div>
          <p>
            Szeretnénk a piac, illetve piaccsarnok forgalmát megemelni, illetve az egész területet vonzóbbá és forgalmasabbá tenni, a tradicionális értékeket megtartani.
          </p>

          <p>
            A rendes karbantartás keretein túl, fenti célok elérése érdekében fejlesztések, felújítások szükségesek. 2015. évben a tulajdonos pályázati és saját forrásokból jelentős összeget fordított a piactér fejlesztésére.
          </p>

        </div>

      </div>

    </section>
  );
};

export default ActivitiesMarket;